import { render, staticRenderFns } from "./HomePlace.vue?vue&type=template&id=3cef7caa&scoped=true&"
import script from "./HomePlace.vue?vue&type=script&lang=js&"
export * from "./HomePlace.vue?vue&type=script&lang=js&"
import style0 from "./HomePlace.vue?vue&type=style&index=0&id=3cef7caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cef7caa",
  null
  
)

export default component.exports